const consumerFlow = [
  /*** Step 0 ***/
  ["Upgrade", "UpgradeAddresses"],

  /*** Step 1 ***/
  ["UpgradeCompleted"],

  /*** Step 2 ***/
  ["UpgradeCompleted"]

];

export default consumerFlow;
